/* global BMS*/
import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/main.css';
import GameTabs from './gameTabs.js';
import GameEventTabs from './gameEventTabs.js';
import BetSlipModalSliderContainer from './betSlipModalSliderContainer.js';
import Carousel from '../components/carousel3.js';
// import MobileCarousel from '../components/mobileCarousel.js';
import RacingCard from '../modules/racing/containers/racingCard.js';
import SelectedFootballCard from '../modules/football/containers/selectedFootballCard';
import SelectedBasketballCard from '../modules/basketball/containers/selectedBasketballCard';
import FootballCard from '../modules/football/containers/footballCard';
import BasketballCard from '../modules/basketball/containers/basketballCard';
import FirstDownCard from '../modules/firstDown/containers/firstDownCard';
import MatchdayCard from '../modules/matchday/containers/matchdayCard';
import MatchdayTextCard from '../modules/matchday/containers/matchdayTextCard';
import {MATCHDAY_MODULE_TYPE} from "../modules/matchday/constants/identifiers";
import QuickBetCard from '../components/quickBetCard.js';
import ResultCard from '../components/resultCard.js';
import ModalPopup from './modalPopup';
import ListModalPopup from './listModalPopup';
import SettingsScreen from '../components/settingsScreen';
import FullScreenConfirmationPopup from '../components/fullScreenConfirmationPopup';
import HelpPageScreen from '../components/helpPageScreen';
import {getModuleFromEventType} from '../../../helpers/moduleHelpers';
import QuickBetCardMatchDayLeagueTable from '../components/quickBetCardMatchDayLeagueTable';
import MatchdayMoreBets from "../modules/matchday/components/matchdayMoreBets"
import AccumulatorBoostScreen from '../components/accumulatorboostScreen';
import MyOffersPopup from '../components/myOffers';
import RealityCheckWarningScreen from '../components/realityCheckWarningScreen';
import {
    AMERICAN_FOOTBALL_MODULE, BASEBALL_MODULE,
    BASKETBALL_MODULE,
    CRICKET_MODULE,
    FIRST_DOWN_MODULE,
    FOOTBALL_MODULE,
    HELP_PAGE_MODAL_TYPE,
    LIST_NOTIFICATION_MODAL_TYPE,
    MATCHDAY_MODULE, MY_OFFER_LIST_MODAL_TYPE,
    NOTIFICATION_MODAL_TYPE,
    PRE,
    RACING_MODULE,
    REALITY_CHECK_MODAL_TYPE,
    RES,
    SET_VIDEO_FULL_SCREEN_CONFIRMATION,
    SETTINGS_MODAL_TYPE, TENNIS_MODULE,
    VID
} from '../../../constants/identifiers';
import {
    addFullScreenListeners,
    exitFullScreen,
    goFullScreen,
    removeFullScreenListeners
} from '../../../helpers/layoutHelpers';

// actions
import {
    setHasTouchScreen,
    setIsDesktopMode,
    setIsInFullViewPlayer,
    setShowVirtualKeyboard,
    setVideoVisibility
} from '../../../actions/systemActions';

// helpers
import {getText} from '../../../helpers/localization';
import {STARTING_CATEGORY, STARTING_SUBCATEGORY, VIRTUALS} from "../../../constants/games";
import * as CONSTS from "../../../constants/communications";
import {ASSETS_URL, HELP_PAGES_URL, PROMO_ASSETS_URL} from "../../../constants/endpoints";
import device from 'current-device';
import {openCloseModal} from "../../../actions/modalActions";
import UAParser from 'ua-parser-js';
import SelectedAmericanFootballCard from "../modules/americanFootball/containers/selectedAmericanFootballCard";
import AmericanFootballCard from "../modules/americanFootball/containers/americanFootballCard";
import BetSlipModal from './betSlipModal';
import BetSlipAccordion from './../components/betSlipAccordion';
import GamePosters from './../components/gamePosters';
import BetHistory from './betHistory';
import {setIsBetSlipSideView} from './../../../actions/systemActions';
import Header from './../components/header';
import {isPlayerStatusIgnore} from "../modules/racing/helpers/racersHelper";
import {selectGame, setGameControllerState, updatePromoBalanceFromWeb} from '../../../actions/gamesActions';
import {removeNoMoreBetsEvent, setReceivedEvents, setResultCounter} from '../../../actions/eventsActions';
import VerticalScrollController from './verticalScrollController';
import {isMatchdayNMB, isTextBasedGame} from '../modules/matchday/helpers/matchdayHelper';
import {getGameCategoryIndex} from '../helpers/gameHelpers';
import {OPERATOR} from "../../../constants/operator";
import DemoplayNotificationScreen from '../components/demoplayNotificationScreen';
import uiCustomization from '../../../helpers/uiCustomization';
import bmsLogicConfig from '../../../constants/configurations/bmsLogicConfig.json';
import ModalPopup2 from "./modalPopup2";
import GiftForYou  from "../components/giftForYou";
import {getItem} from "../../../helpers/localStorageHelpers";
import {HIDE_GIFT_FOR_YOU, HIDE_GIFT_TILL, VID_VISIBLE} from "../../../constants/localStorage";
import MyOffersList from '../components/myOffersList'
import TermsAndConditions  from "../components/termsAndConditions";
import {isLocalStorageAvailable} from "../../../helpers/systemHelpers";
import SwipeablePromoMobileBanner from "../components/promoCarousel";
import Porthole from "porthole-proxy";
import SelectedCricketCard from "../modules/cricket/containers/selectedCricketCard";
import CricketCard from "../modules/cricket/containers/cricketCard";
import SelectedTennisCard from "../modules/tennis/containers/selectedTennisCard";
import TennisCard from "../modules/tennis/containers/tennisCard";
import SelectedBaseballCard from '../modules/baseball/containers/selectedBaseballCard';
import BaseballCard from '../modules/baseball/containers/baseballCard';
import MatchdayLiveScoreCard from '../components/matchdayLiveScoreCard.js';
// this is also defined in global css vars under --sportsBookCarouselIFrameWidth
let resizeWidthInPx = 550;
let previousSelectedGameIndex;
let itemsUI;
const betSlipSideViewThreshold = 950;
//const matchday_events = require("./matchdayEvents.json")

const mapStateToProps = (state, ownProps) => {
    return {
        systemLanguage: state.vpp.systemLanguage,
        selectedGameIndex: state.vpp.selectedGameIndex,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedEventId: state.vpp.selectedEventId,
        games: state.vpp.games,
        events: state.vpp.events,
        isDesktopMode: state.vpp.isDesktopMode,
        isSettingsOpen: state.vpp.isSettingsOpen,
        isHelpPagesOpen: state.vpp.isHelpPagesOpen,
        isModalOpen: state.vpp.isModalOpen,
        openModalType: state.vpp.openModalType,
        isVideoVisible: state.vpp.isVideoVisible,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        loadingBarPercentage: state.vpp.loadingBarPercentage,
        isInFullViewPlayer: state.vpp.isInFullViewPlayer,
        isBetSlipModalOpen: state.vpp.isBetSlipModalOpen,
        openBetsList: state.vpp.openBetsList,
        isBetHistoryOpen: state.vpp.isBetHistoryOpen,
        isBetSlipSideView: state.vpp.isBetSlipSideView,
        showHeader: state.vpp.showHeader,
        selectedMatchdayEventId: state.vpp.matchday.selectedMatchdayEventId,
        matchdayUpdated: state.vpp.matchdayUpdated,
        selectedMatchdaySubEventIndex: state.vpp.selectedMatchdaySubEventIndex,
        isAccumulatorBoostPagesOpen: state.vpp.isAccumulatorBoostPagesOpen,
        isRealityCheckWarningOpen: state.vpp.isRealityCheckWarningOpen,
        isDemoplayNotificationOpen: state.vpp.isDemoplayNotificationOpen,
        isGiftForYouOpen: state.vpp.isGiftForYouOpen,
        isMyOffersPopupOpen: state.vpp.isMyOffersPopupOpen,
        isMyOffersListPopup : state.vpp.isMyOffersListPopup,
        isTermsAndConditionsPopupOpen : state.vpp.isTermsAndConditionsPopupOpen,
    };
};

class Main extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();
        this._setBetSlipView = this._setBetSlipView.bind(this);
        this._updateDimensions = this._updateDimensions.bind(this);
        this.lastUpdatedWidth = window.innerWidth;
        this.lastUpdatedHeight = window.innerHeight;
        this.topContainerRef = React.createRef();
        this.gametabContainerRef = React.createRef();
        this.headerRef = React.createRef();
        this.betslipModalRef = React.createRef();

        this.state = {
            systemLanguage: storeData.vpp.systemLanguage,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedEventId: storeData.vpp.selectedEventId,
            events: storeData.vpp.events,
            games: storeData.vpp.games,
            isDesktopMode: storeData.vpp.isDesktopMode,
            isSettingsOpen: storeData.vpp.isSettingsOpen,
            isHelpPagesOpen: storeData.vpp.isHelpPagesOpen,
            isModalOpen: storeData.vpp.isModalOpen,
            openModalType: storeData.vpp.openModalType,
            isVideoVisible: storeData.vpp.isVideoVisible,
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            loadingBarPercentage: storeData.vpp.loadingBarPercentage,
            matchdayUpdated: storeData.vpp.matchdayUpdated,
            isContainerInFullScreen: false,
            isInFullViewPlayer: storeData.vpp.isInFullViewPlayer,
            isContainerInFullPage: false,
            isSupportedBrowser: true,
            isBetSlipModalOpen: false,
            openBetsList: storeData.vpp.openBetsList,
            isBetHistoryOpen: storeData.vpp.isBetHistoryOpen,
            isBetSlipSideView: storeData.vpp.isBetSlipSideView,
            showHeader: storeData.vpp.showHeader,
            webPlayerVideoStatus: undefined,
            selectedMatchdayEventId: storeData.vpp.matchday.selectedMatchdayEventId,
            selectedMatchdaySubEventIndex: storeData.vpp.selectedMatchdaySubEventIndex,
            isAccumulatorBoostPagesOpen: storeData.vpp.isAccumulatorBoostPagesOpen,
            isRealityCheckWarningOpen: storeData.vpp.isRealityCheckWarningOpen,
            isDemoplayNotificationOpen: storeData.vpp.isDemoplayNotificationOpen,
            isScrollTopButtonVisible: false,
            isGiftForYouOpen: storeData.vpp.isGiftForYouOpen,
            isMyOffersPopupOpen: storeData.vpp.isMyOffersPopupOpen,
            isMyOffersListPopup : storeData.vpp.isMyOffersListPopup,
            isTermsAndConditionsPopupOpen : storeData.vpp.isTermsAndConditionsPopupOpen,
            dataFromWeb: []
        };

        if (process.env.NODE_ENV !== 'development') {
            BMS.Operator.init();
        }

        // evoke game loading events
        if (process.env.NODE_ENV !== 'development' && BMS && BMS.Operator && BMS.Operator.setLoadingPercentage) {
            // let GCM know that game loaded is started and currently on zero percent
            BMS.Operator.setLoadingPercentage(0);
        }

        if (this.state.isDesktopMode === true && (window.innerWidth <= resizeWidthInPx)) {
            store.dispatch(setIsDesktopMode(false));
        }

    }
    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                systemLanguage: storeData.vpp.systemLanguage,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                selectedEventId: storeData.vpp.selectedEventId,
                events: storeData.vpp.events,
                games: storeData.vpp.games,
                isDesktopMode: storeData.vpp.isDesktopMode,
                isSettingsOpen: storeData.vpp.isSettingsOpen,
                isHelpPagesOpen: storeData.vpp.isHelpPagesOpen,
                isModalOpen: storeData.vpp.isModalOpen,
                openModalType: storeData.vpp.openModalType,
                isVideoVisible: storeData.vpp.isVideoVisible,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                loadingBarPercentage: storeData.vpp.loadingBarPercentage,
                isInFullViewPlayer: storeData.vpp.isInFullViewPlayer,
                matchdayUpdated: storeData.vpp.matchdayUpdated,
                isBetSlipModalOpen: storeData.vpp.isBetSlipModalOpen,
                isBetHistoryOpen: storeData.vpp.isBetHistoryOpen,
                isBetSlipSideView: storeData.vpp.isBetSlipSideView,
                showHeader: storeData.vpp.showHeader,
                selectedMatchdayEventId: storeData.vpp.matchday.selectedMatchdayEventId,
                selectedMatchdaySubEventIndex: storeData.vpp.selectedMatchdaySubEventIndex,
                isAccumulatorBoostPagesOpen: storeData.vpp.isAccumulatorBoostPagesOpen,
                isRealityCheckWarningOpen: storeData.vpp.isRealityCheckWarningOpen,
                isDemoplayNotificationOpen: storeData.vpp.isDemoplayNotificationOpen,
                isGiftForYouOpen: storeData.vpp.isGiftForYouOpen,
                isMyOffersPopupOpen: storeData.vpp.isMyOffersPopupOpen,
                isMyOffersListPopup : storeData.vpp.isMyOffersListPopup,
                isTermsAndConditionsPopupOpen : storeData.vpp.isTermsAndConditionsPopupOpen
            });
        }

    }

    componentWillMount() {
        // evoke game loading events
        if (process.env.NODE_ENV !== 'development' && BMS && BMS.Operator && BMS.Operator.setLoadingPercentage) {
            // let GCM know that the game is half way loaded
            BMS.Operator.setLoadingPercentage(50);
        }
    }

    componentDidMount() {
        this.fetchCampaignsWithWaggeringLimit();
        document.getElementById('bottomContainer').addEventListener("scroll", this._scrollHandler.bind(this));
        document.getElementById('gameIframe').addEventListener("scroll", this._scrollHandler.bind(this));
        document.getElementsByTagName("html")[0].lang = OPERATOR.defaultLanguage;
        window.addEventListener('resize', this._updateDimensions);
        window.addEventListener('orientationchange', this._setBetSlipView);
        if (device.mobile() && !device.tablet()) {
            if (window.screen.orientation && window.orientation !== undefined) {
                window.screen.orientation.onchange = this._orientationChange.bind(this);
                addFullScreenListeners(() => this._fullScreenHandler());
            } else if (window.orientation !== undefined) {
                window.addEventListener('orientationchange', this._fullPageHandler.bind(this));
            }
        }

        if (this._enableTouchScreenMode()) {
            this.props.store.dispatch(setHasTouchScreen(true));
        }
        try {
            if (JSON.parse(localStorage.getItem('showVPPVirtualKeyboard')) === true) {
                this.props.store.dispatch(setShowVirtualKeyboard(true));
            }
        } catch (e) {
            console.log('Cannot open virtual keyboard');
        }

        // check if browser is supported
        const browser = new UAParser(window.navigator.userAgent).getBrowser().name;
        // supported browsers: firefox, chrome, safari and edge
        let isSupportedBrowser = /^.*(?:firefox|chrome|safari|edge|WebKit|opera).*$/i.test(browser);

        this.setState({isSupportedBrowser: isSupportedBrowser});

        // evoke game loading events
        if (process.env.NODE_ENV !== 'development' && BMS && BMS.Operator) {
            // let GCM know that the game as loaded successfully
            if (BMS.Operator.setLoadingPercentage) {
                BMS.Operator.setLoadingPercentage(100);
            }
            // let GCM know that the game is ready to be played
            if (BMS.Operator.gameReady) {
                BMS.Operator.gameReady();
            }
        }

        this._setBetSlipView()
        this._selectDeepLinkedGame()

        if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
            ? bmsLogicConfig.customization
            : BMS
                ? BMS.customization
                : false) {
            uiCustomization();
        }
    }
    fetchCampaignsWithWaggeringLimit(){
        if(OPERATOR.currency != 'XXX' && OPERATOR.promoToolEnabled && !OPERATOR.pushApiPromoToolEnabled){
            fetch(PROMO_ASSETS_URL+'promoBalance.json',{cache: "no-store"})
                .then(response => response.json())
                .then(data => {
                    this.setState({dataFromWeb:data});
                    this.props.store.dispatch(updatePromoBalanceFromWeb(this.state.dataFromWeb));
                })
                .catch((error) => console.log('Error retrieving promoBalance.', error));}
    }
    _selectDeepLinkedGame() {
        // in case of starting category defined, change selectedGameIndex to be the fist game of that category.
        let selectedGameIndex = VIRTUALS.findIndex((game) => game.category.name === STARTING_CATEGORY);
        selectedGameIndex = (selectedGameIndex >= 0 ? selectedGameIndex : 0);// sets to zero,if category not found
        let selectedSubCategoryIndex = VIRTUALS.findIndex((game)=> game.channel === STARTING_SUBCATEGORY );
        selectedSubCategoryIndex = (selectedSubCategoryIndex >= 0 ? selectedSubCategoryIndex : selectedGameIndex);
        this.props.store.dispatch(selectGame(selectedSubCategoryIndex, this.props.store));

        if (!this.state.isInFullViewPlayer) {
            this._scrollGameTabs(selectedSubCategoryIndex);
            let selectedGameCategoryTab = document.getElementById('gameCategoryTab_' + (VIRTUALS[selectedSubCategoryIndex].category.displayOrder - 1));
            selectedGameCategoryTab.click(); // This is required to remember the scroll position, so as to restore the position after flipping
        }
    }

    _enableTouchScreenMode() {
        var userAgent = navigator.userAgent;

        var mobile = userAgent.match(/Android/i) ||
            userAgent.match(/BlackBerry/i) ||
            userAgent.match(/iPhone|iPad|iPod/i) ||
            userAgent.match(/Opera Mini/i) ||
            userAgent.match(/IEMobile/i);

        if (mobile) {
            return true;
        } else {
            // Since newer ios releases (ios 13+) for iPad no longer send iPad in the user agent, we need to cover this condition.
            return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
        }
    }

    _scrollGameTabs(gameIndex) {
        if (gameIndex !== undefined) {
            const tabWidth = document.getElementById('gameCategoryTab_0').offsetWidth;
            let gameTabsContainer = document.getElementById('gameTabsContainer');
            let scrollDistance = tabWidth * getGameCategoryIndex(gameIndex);
            if(window.innerWidth <950){
                gameTabsContainer.scrollLeft = gameTabsContainer.scrollLeft + scrollDistance;
            }
        }
    }

    _orientationChange() {
        if ((window.orientation === -90 || window.orientation === 90) && !this.state.isContainerInFullScreen) {
            if (navigator.userAgent.search("Firefox") > -1) {
                this.props.store.dispatch(openCloseModal(SET_VIDEO_FULL_SCREEN_CONFIRMATION));
            } else {
                goFullScreen('video-iframe-container').catch(error => {
                    this.setState({isContainerInFullScreen: true});
                    this.props.store.dispatch(setIsInFullViewPlayer(true));
                });
            }
        } else {
            if (navigator.userAgent.search("Firefox") > -1 && this.state.openModalType === SET_VIDEO_FULL_SCREEN_CONFIRMATION) {
                this.props.store.dispatch(openCloseModal());
            }

            if (this.state.isInFullViewPlayer) {
                this.setState({isContainerInFullScreen: false});
                this.props.store.dispatch(setIsInFullViewPlayer(false));
            }

            if (this.state.isContainerInFullScreen) {
                exitFullScreen();
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener('resize', this._updateDimensions());
        window.removeEventListener('orientationchange', this._setBetSlipView);
        document.getElementById('bottomContainer').removeEventListener("scroll", this._scrollHandler.bind(this));
        document.getElementById('gameIframe').removeEventListener("scroll", this._scrollHandler.bind(this));
        if (window.screen.orientation && window.orientation !== undefined) {
            window.screen.orientation.onchange = null;
            removeFullScreenListeners(() => this._fullScreenHandler());
        } else if (window.orientation !== undefined) {
            window.parent.removeEventListener('orientationchange', this._fullPageHandler.bind(this));
        }

    }

    componentDidUpdate() {
        this._handleContainerHeight();
    }

    _handleContainerHeight() {
        let isMatchday = this.state.games[this.state.selectedGameIndex].type === MATCHDAY_MODULE_TYPE;
        let totalHeaderHeight, gameTabContainerHeight, topHeaderHeight;
        let totalViewHeight = window.innerHeight;
        const betslipHeight = 47;
        topHeaderHeight = this.headerRef.current ? this.headerRef.current.clientHeight : 0;
        totalHeaderHeight = (this.topContainerRef.current ? this.topContainerRef.current.clientHeight : 0) + topHeaderHeight;
        if (window.innerWidth > 950) {
            //For Desktop View
            this.desktopContainerHeight = totalViewHeight - totalHeaderHeight;
            this.mobileContainerHeight = undefined;
        } else {
            // mobile view config
            let bannerHeight = document.getElementById("mobileBannerId") ? document.getElementById("mobileBannerId").clientHeight : 0;
            this.mobileContainerHeight = totalViewHeight - (totalHeaderHeight + betslipHeight + bannerHeight);
            this.desktopContainerHeight = undefined;
            gameTabContainerHeight = this.gametabContainerRef.current ? this.gametabContainerRef.current.clientHeight : 0;
            let modalHeight = totalViewHeight - (isMatchday ? gameTabContainerHeight + topHeaderHeight + betslipHeight : totalHeaderHeight + 17 );
            if (!this.state.betslipModalHeight || this.state.betslipModalHeight != modalHeight) {
                this.setState({...this.state, betslipModalHeight: modalHeight});
            }
        }
    }

    _fullScreenHandler() {
        if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
            this.setState({isContainerInFullScreen: true});
        } else {
            this.setState({isContainerInFullScreen: false});
        }
    }

    _fullPageHandler() {
        let isLandscape = false;
        if (window.orientation === -90 || window.orientation === 90) {
            isLandscape = true;
        }

        this.setState({isContainerInFullPage: isLandscape});

        if (window.parent.setOperatorLandscape !== undefined && window.parent.setOperatorLandscape !== null) {
            window.parent.setOperatorLandscape(isLandscape);
        }
    }

    _scrollTopButtonClickHandler(e) {
        document.getElementById("bottomContainer").scrollTo({top: 0, behavior: 'smooth'}); //for desktop view
        document.getElementById('gameIframe').scrollTo({top: 0, behavior: 'smooth'});  //for mobile view
    }

    _scrollHandler(event) {

        if (!this.state.isScrollTopButtonVisible && event.target.scrollTop > 10) {
            this.setState({isScrollTopButtonVisible: true});
        } else if (this.state.isScrollTopButtonVisible && event.target.scrollTop <= 10) {
            this.setState({isScrollTopButtonVisible: false});
        }
    }

    _show() {
        this.setState({hidden: false});
    }

    _setBetSlipView() {
        if (document.getElementById('root').offsetWidth > betSlipSideViewThreshold && !this.state.isBetSlipSideView) {
            this.props.store.dispatch(setIsBetSlipSideView(true));
        } else if (document.getElementById('root').offsetWidth < betSlipSideViewThreshold && this.state.isBetSlipSideView) {
            this.props.store.dispatch(setIsBetSlipSideView(false));
        }
    }

    getAttractScreenForLandscapeView() {
        let store = this.props.store;
        let storeData = store.getState();
        let isMatchdayChannel = storeData.vpp.games[this.state.selectedGameIndex].type === MATCHDAY_MODULE_TYPE;
        //Start Remove this logic as this is a temp fix done for result screen issues. PROD_VSB-2238. This needs to be removed in 2.1.0
        let webPlayerVideoStatus;

        let channel = storeData.vpp.games[this.state.selectedGameIndex].channel;
        if ((isPlayerStatusIgnore(channel) || isTextBasedGame(channel)) && this.state.webPlayerVideoStatus !== "STOPPED") {
            //TODO: Remove this logic as this is a temp fix done.
            let selectedRacingLastResult = storeData.vpp.games[this.state.selectedGameIndex].lastResult;
            if (isTextBasedGame(channel) || (selectedRacingLastResult
                && storeData.vpp.events
                && storeData.vpp.events[0]
                && storeData.vpp.events[0].channel === selectedRacingLastResult.channel
                && Number(selectedRacingLastResult.eventId) === storeData.vpp.events[0].eventId
                && storeData.vpp.games[this.state.selectedGameIndex].controllerState === CONSTS.VC2_MESSAGE_TYPE.RES)) {
                setTimeout(() => {
                    this._updateState("STOPPED");
                }, isTextBasedGame(channel) ? 0 : 9000);
            }
        }
        webPlayerVideoStatus = this.state.webPlayerVideoStatus;

        if ((isMatchdayChannel ? (this.state.selectedEventIndex === 0 ? !this.state.games[this.state.selectedGameIndex].isResultShowing : true) : !this.state.games[this.state.selectedGameIndex].isResultShowing) && ((storeData.vpp.games[this.state.selectedGameIndex].controllerState === CONSTS.VC2_MESSAGE_TYPE.PRE || storeData.vpp.games[this.state.selectedGameIndex].controllerState === CONSTS.VC2_MESSAGE_TYPE.NMB)
            || ((isMatchdayChannel && this.state.selectedEventIndex !== 0) || (this.state.games[this.state.selectedGameIndex].controllerState != undefined && this.state.games[this.state.selectedGameIndex].controllerState[1] != undefined
                && (this.state.games[this.state.selectedGameIndex].controllerState[1] === CONSTS.VC2_MESSAGE_TYPE.PRE || this.state.games[this.state.selectedGameIndex].controllerState[1] === CONSTS.VC2_MESSAGE_TYPE.NMB))))) {
            return (<QuickBetCard store={this.props.store} showCounter={true}/>);
        } else if ((!isMatchdayChannel && this.state.games[this.state.selectedGameIndex].isResultShowing)
            || (isMatchdayChannel && this.state.games[this.state.selectedGameIndex].isResultShowing && this.state.selectedEventIndex === 0)
            || ((storeData.vpp.games[this.state.selectedGameIndex].controllerState === CONSTS.VC2_MESSAGE_TYPE.RES
                    || (this.state.selectedEventIndex === 0
                        && this.state.games[this.state.selectedGameIndex].controllerState !== undefined
                        && this.state.games[this.state.selectedGameIndex].controllerState[this.state.selectedMatchdaySubEventIndex + 1] != undefined
                        && this.state.games[this.state.selectedGameIndex].controllerState[this.state.selectedMatchdaySubEventIndex + 1] === CONSTS.VC2_MESSAGE_TYPE.RES))
                && (storeData.vpp.games[this.state.selectedGameIndex].isResulted || webPlayerVideoStatus === "STOPPED"))) {
            if (storeData.vpp.games[this.state.selectedGameIndex].isResultCountDownStart === true) {
                let gameIndex = this.state.selectedGameIndex;
                if (isMatchdayChannel) {
                    setTimeout(() => {
                        store.dispatch(setResultCounter(storeData.vpp.games[gameIndex].channel, false, true));
                    }, 7000);
                } else {
                    store.dispatch(setResultCounter(storeData.vpp.games[gameIndex].channel, false, true));
                }
                setTimeout(function () {
                    this.props.store.dispatch(setResultCounter(this.props.store.getState().vpp.games[gameIndex].channel, false, false));
                    if (isMatchdayChannel) {
                        this.props.store.dispatch(setGameControllerState(this.props.store.getState().vpp.games[gameIndex].channel, CONSTS.VC2_MESSAGE_TYPE.PRE, true, true))
                    } else {
                        this.props.store.dispatch(setGameControllerState(this.props.store.getState().vpp.games[gameIndex].channel, CONSTS.VC2_MESSAGE_TYPE.PRE));
                    }
                    this.props.store.dispatch(setReceivedEvents([], true, this.props.store.getState().vpp.games[gameIndex].channel));
                    this.props.store.dispatch(removeNoMoreBetsEvent(this.props.store.getState().vpp.games[gameIndex].channel));
                }.bind(this), isMatchdayChannel ? 17000 : 10000);
            } else if (storeData.vpp.games[this.state.selectedGameIndex].isResultCountDownStart === undefined) {
                if (isMatchdayChannel) {
                    this.props.store.dispatch(setGameControllerState(storeData.vpp.games[this.state.selectedGameIndex].channel, CONSTS.VC2_MESSAGE_TYPE.PRE, true, true))
                } else {
                    this.props.store.dispatch(setGameControllerState(storeData.vpp.games[this.state.selectedGameIndex].channel, CONSTS.VC2_MESSAGE_TYPE.PRE));
                }
                store.dispatch(setReceivedEvents([], true, storeData.vpp.games[this.state.selectedGameIndex].channel));
                store.dispatch(removeNoMoreBetsEvent(storeData.vpp.games[this.state.selectedGameIndex].channel));
            }
            if (storeData.vpp.games[this.state.selectedGameIndex].isResultCountDownStart !== undefined && (webPlayerVideoStatus === undefined || webPlayerVideoStatus === "STOPPED")) {
                return (<ResultCard store={this.props.store}/>);
            }
            //END Remove this logic as this is a temp fix done for result screen issues. PROD_VSB-2238. This needs to be removed in 2.1.0
        } else {
            if (isMatchdayChannel && isTextBasedGame(channel))
                return (<MatchdayLiveScoreCard store={this.props.store}/>);
            return '';
        }
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let isMatchdayChannel = storeData.vpp.games[this.state.selectedGameIndex].type === MATCHDAY_MODULE_TYPE;
        let channel =  storeData.vpp.games[this.state.selectedGameIndex].channel;
        if (!this.state.isSupportedBrowser) {
            return (<div className={style.ieWarningContainer}>
                <h1>{getText('BROWSER_NOT_SUPPORTED', this.props.store)}</h1>
                <div className={style.ieWarning}>{getText('BROWSER_NOT_SUPPORTED_DETAILS', this.props.store)}</div>
                <a className={style.downloadLink} href={'https://www.google.com/chrome/'}
                   target="_blank">{getText('DOWNLOAD_CHROME', this.props.store)}</a>
                <a className={style.downloadLink} href={'https://www.mozilla.org/'}
                   target="_blank">{getText('DOWNLOAD_FIREFOX', this.props.store)}</a>
            </div>);
        }

        let selectedEvent = (this.state.events && this.state.events.length)
            ? this.state.events[this.state.selectedEventIndex]
            : undefined;
        let isBannerAvailable = (this.state.events && this.state.events.length && this.state.games[this.state.selectedGameIndex].channel === this.state.events[this.state.selectedEventIndex].channel)
            ? this.state.events[this.state.selectedEventIndex]
            : undefined;

        if (this.state.isContainerInFullPage) {
            let videoUrl;
            if (isMatchdayChannel)
                videoUrl = VIRTUALS[this.state.selectedGameIndex].URL.VIDEO_URL + '_' + (parseInt(this.state.selectedMatchdaySubEventIndex, 10) + 1);
            else
                videoUrl = VIRTUALS[this.state.selectedGameIndex].URL.VIDEO_URL;

            if (isTextBasedGame(channel)) {
                return (<div className={style.videoIframeContainer}>
                    {this.getAttractScreenForLandscapeView()}
                </div>)
            } else {
                return (<div className={style.videoIframeContainer}>
                    <iframe name='videoiframe' id='video-iframe' src={videoUrl} frameBorder='0'
                        title={VIRTUALS[this.state.selectedGameIndex].name} className={style.videoIframe} />
                    {this.getAttractScreenForLandscapeView()}
                </div>)
            }
        }

        let gameCard;
        let leagueUpdate;
        let selectedFootballCard;
        let selectedBasketballCard;
        let selectedAmericanFootballCardCard;
        let overlay;
        let gameEventTabs;
        let noFutureEventsCard;
        let isDisplayMatchdayMoreBetsScreen = this.state.selectedMatchdayEventId;

        let scrollTopButtonClass = this.state.isScrollTopButtonVisible ?
            `${style.scrollTopButton} ${style.show}`
            : style.scrollTopButton
        let scrollTopButton = (
            <div className={scrollTopButtonClass} onClick={() => this._scrollTopButtonClickHandler()}>
                <img className={style.arrowImage} src={`${ASSETS_URL}next.svg`} alt='next'/>
            </div>);

        if (storeData.vpp.nextEventsTimeStamp.find((event) => event.channel === storeData.vpp.games[this.state.selectedGameIndex].channel && Number(event.eventTime)) === undefined) {
            noFutureEventsCard = (<div className={style.noFutureEventsCard}>
                {getText('NO_FUTURE_EVENTS', this.props.store)}
            </div>);
            gameEventTabs =
                <GameEventTabs id='gameEventTabs' store={this.props.store} hasSelectedGameFutureEvents={false}/>;
        } else {

            if ((this.state.events.length > 0 && storeData.vpp.games.length > 0 && this.state.events[0] !== undefined && this.state.events[0].channel !== storeData.vpp.games[this.state.selectedGameIndex].channel)
                || (process.env.NODE_ENV !== 'development'
                    ? (storeData.vpp.games[this.state.selectedGameIndex].type === MATCHDAY_MODULE_TYPE
                        ? this.state.matchdayUpdated === false
                        : false)
                    : false)) {
                overlay = (<div className={style.loadingOverlay}>
                    <div className={style.loaderContainer}>
                        <div className={style.circleLoaderContainer}>
                            <div className={style.circleLoader}/>
                        </div>
                        {/*<div className={style.loadingText}>{getText('LOADING', this.props.store)}</div>*/}
                    </div>
                </div>)
            }

            if (selectedEvent) {
                let module = getModuleFromEventType(selectedEvent.eventType);

                switch (module) {
                    case RACING_MODULE:
                        gameCard = (
                            <RacingCard id='racingCard' store={this.props.store} showLoadingOverlay={overlay}/>);
                        break;
                    case FOOTBALL_MODULE:
                        selectedFootballCard = isBannerAvailable ? (
                            <div id={'gameCardContainer'} className={style.selectedGameController}>
                                <div id={'gameCard'} className={style.selectedGameContainer}>
                                    <SelectedFootballCard id='selectedFootballCard' store={this.props.store}
                                                          showLoadingOverlay={overlay} showActive={false}/>
                                </div>
                            </div>) : '';
                        gameCard = (
                            <FootballCard id='footballCard' store={this.props.store} showLoadingOverlay={overlay}/>);
                        break;
                    case BASKETBALL_MODULE:
                        selectedBasketballCard = isBannerAvailable ? (
                            <div id={'gameCardContainer'} className={style.selectedGameController}>
                                <div id={'gameCard'} className={style.selectedInsideContainer}>
                                    <SelectedBasketballCard id='selectedBasketballCard' store={this.props.store}
                                                            showLoadingOverlay={overlay} showActive={false}/>
                                </div>
                            </div>) : '';
                        gameCard = (
                            <BasketballCard id='footballCard' store={this.props.store} showLoadingOverlay={overlay}/>);
                        break;
                    case AMERICAN_FOOTBALL_MODULE:
                        selectedAmericanFootballCardCard = isBannerAvailable ? (
                            <div id={'gameCardContainer'} className={style.selectedGameController}>
                                <div id={'gameCard'} className={style.selectedInsideContainer}>
                                    <SelectedAmericanFootballCard id='selectedBasketballCard' store={this.props.store}
                                                                  showLoadingOverlay={overlay} showActive={false}/>
                                </div>
                            </div>) : '';
                        gameCard = (<AmericanFootballCard id='footballCard' store={this.props.store}
                                                          showLoadingOverlay={overlay}/>);
                        break;
                    case FIRST_DOWN_MODULE:
                        gameCard = (
                            <FirstDownCard id='firstDownCard' store={this.props.store} showLoadingOverlay={overlay}/>);
                        break;
                    case MATCHDAY_MODULE:
                        if (device.mobile()
                            && !device.tablet()) {
                            if (window.screen.orientation && window.orientation !== undefined) {
                                if (window.orientation === -90 || window.orientation === 90) {
                                    if (isTextBasedGame(channel)) {
                                        return (<div className={style.videoIframeContainer}>
                                            {this.getAttractScreenForLandscapeView()}
                                        </div>)
                                    } else {
                                        return (<div className={style.videoIframeContainer}>
                                            <iframe id='video-iframe' name='videoiframe'
                                                    src={VIRTUALS[this.state.selectedGameIndex].URL.VIDEO_URL + '_' + (parseInt(this.state.selectedMatchdaySubEventIndex, 10) + 1)}
                                                    frameBorder='0'
                                                    title={VIRTUALS[this.state.selectedGameIndex].name}
                                                    className={style.videoIframe}/>
                                            {this.getAttractScreenForLandscapeView()}
                                        </div>);
                                    }
                                }
                            } else if (window.orientation !== undefined) {
                                if (window.orientation === -90 || window.orientation === 90) {
                                    if (isTextBasedGame(channel)) {
                                        return (<div className={style.videoIframeContainer}>
                                            {this.getAttractScreenForLandscapeView()}
                                        </div>)
                                    } else {
                                        return (<div className={style.videoIframeContainer}>
                                            <iframe id='video-iframe' name='videoiframe'
                                                    src={VIRTUALS[this.state.selectedGameIndex].URL.VIDEO_URL + '_' + (parseInt(this.state.selectedMatchdaySubEventIndex, 10) + 1)}
                                                    frameBorder='0'
                                                    title={VIRTUALS[this.state.selectedGameIndex].name}
                                                    className={style.videoIframe}/>
                                            {this.getAttractScreenForLandscapeView()}
                                        </div>);
                                    }
                                }
                            }
                        }
                        if (!isDisplayMatchdayMoreBetsScreen) {
                            if(isTextBasedGame(this.state.games[this.state.selectedGameIndex].channel)){
                                gameCard = (<MatchdayTextCard id='matchdayTextCard' store={this.props.store} overlay={overlay}/>);
                            }else{
                                gameCard = (<MatchdayCard id='matchdayCard' store={this.props.store} overlay={overlay}/>);
                                if (this.state.selectedEventIndex !== 0 || (
                                    this.state.games[this.state.selectedGameIndex].controllerState != undefined
                                    && this.state.games[this.state.selectedGameIndex].controllerState[1] != undefined
                                    && this.state.games[this.state.selectedGameIndex].controllerState[1] === PRE
                                    && !isMatchdayNMB(storeData)
                                    && this.state.events && this.state.events.length
                                    && this.state.games[this.state.selectedGameIndex].channel === this.state.events[this.state.selectedEventIndex].channel))
                                    leagueUpdate = <QuickBetCardMatchDayLeagueTable id='MatchDayLeagueTable'
                                                                                    store={this.props.store}/>;
                            }
                        }
                        break;
                    case CRICKET_MODULE:
                        selectedFootballCard = isBannerAvailable ? (
                            <div id={'gameCardContainer'} className={style.selectedGameController}>
                                <div id={'gameCard'} className={style.selectedGameContainer}>
                                    <SelectedCricketCard id='selectedFootballCard' store={this.props.store}
                                                          showLoadingOverlay={overlay} showActive={false}/>
                                </div>
                            </div>) : '';
                        gameCard = (
                            <CricketCard id='footballCard' store={this.props.store} showLoadingOverlay={overlay}/>);
                        break;
                    case TENNIS_MODULE:
                        selectedFootballCard = isBannerAvailable ? (
                            <div id={'gameCardContainer'} className={style.selectedGameController}>
                                <div id={'gameCard'} className={style.selectedGameContainer}>
                                    <SelectedTennisCard id='selectedFootballCard' store={this.props.store}
                                                         showLoadingOverlay={overlay} showActive={false}/>
                                </div>
                            </div>) : '';
                        gameCard = (
                            <TennisCard id='footballCard' store={this.props.store} showLoadingOverlay={overlay}/>);
                        break;
                    case BASEBALL_MODULE:
                        selectedFootballCard = isBannerAvailable ? (
                            <div id={'gameCardContainer'} className={style.selectedGameController}>
                                <div id={'gameCard'} className={style.selectedGameContainer}>
                                    <SelectedBaseballCard id='selectedFootballCard' store={this.props.store}
                                                         showLoadingOverlay={overlay} showActive={false}/>
                                </div>
                            </div>) : '';
                        gameCard = (
                            <BaseballCard id='footballCard' store={this.props.store} showLoadingOverlay={overlay}/>);
                        break;
                    default:
                        gameCard = (<div></div>);
                        break;
                }
            }
            if (this.state.games[this.state.selectedGameIndex].type === MATCHDAY_MODULE_TYPE && !isTextBasedGame(this.state.games[this.state.selectedGameIndex].channel)) {
                if (!isDisplayMatchdayMoreBetsScreen) {
                    if (this.props.store.getState().vpp.selectedEventIndex == 0
                        && (this.state.games[this.state.selectedGameIndex].controllerState
                            && this.state.games[this.state.selectedGameIndex].controllerState[1]
                            && (this.state.games[this.state.selectedGameIndex].controllerState[1] === VID
                                || this.state.games[this.state.selectedGameIndex].controllerState[1] === RES
                                || isMatchdayNMB(storeData)))) {
                        //show only while game iframe is present on the screen
                        gameEventTabs = <GameEventTabs id='gameEventTabs' store={this.props.store}
                                                       hasSelectedGameFutureEvents={true}/>;
                    }
                }
            } else {
                gameEventTabs =
                    <GameEventTabs id='gameEventTabs' store={this.props.store} hasSelectedGameFutureEvents={true}/>;
            }
        }

        let carouselType;
        let matchdayMoreBets;
        if (isDisplayMatchdayMoreBetsScreen) {
            matchdayMoreBets =
                <MatchdayMoreBets store={this.props.store} updateCallback={() => this._handleContainerHeight()}/>;
        } else {
            if (this.state.isVideoVisible || isTextBasedGame(this.state.games[this.state.selectedGameIndex].channel)) {
                carouselType = <Carousel id='carousel' store={this.props.store}/>;
            }
        }


        let modalUI, popupUI = '';

        if (this.state.isModalOpen) {
            switch (this.state.openModalType) {
                case NOTIFICATION_MODAL_TYPE:
                    modalUI = (
                        <ModalPopup id='notificationPopup' store={this.props.store}
                                    modalType={NOTIFICATION_MODAL_TYPE}/>);
                    break;
                case SET_VIDEO_FULL_SCREEN_CONFIRMATION:
                    modalUI = (<ModalPopup id='setVideoFullScreenConfirmation'
                                           store={this.props.store} modalType={SET_VIDEO_FULL_SCREEN_CONFIRMATION}
                                           title={getText('SET_VIDEO_ON_FUL_SCREEN', this.props.store)}
                                           content={(<FullScreenConfirmationPopup store={this.props.store}/>)}/>);
                    break;
                case LIST_NOTIFICATION_MODAL_TYPE:
                    modalUI = (
                        <ListModalPopup id='notificationPopup' store={this.props.store}
                                    modalType={LIST_NOTIFICATION_MODAL_TYPE}/>);
                    break;
                default:
                    return null;
            }
        }
        let hideGiftForYou;
        let hideGiftForYouFromLS = false;
        //localStorage
        if (isLocalStorageAvailable) {
            if(Date.now()> getItem(storeData.vpp.playerUID, HIDE_GIFT_TILL)){
                localStorage.removeItem(HIDE_GIFT_FOR_YOU);
            }
            hideGiftForYou = getItem(storeData.vpp.playerUID, HIDE_GIFT_FOR_YOU);

            if(!OPERATOR.showHideVideo){
                this.props.store.dispatch(setVideoVisibility(this.props.store.getState().vpp.playerUID, true));
            }

        }
        if(hideGiftForYou !== null ){
            if(hideGiftForYou !== false){
                hideGiftForYouFromLS=true;
            }
        }
        if (this.state.isSettingsOpen) {
            popupUI = this.state.isSettingsOpen &&
                <ModalPopup id='settingsPopup' store={this.props.store} modalType={SETTINGS_MODAL_TYPE}
                            title={getText('SETTINGS', this.props.store)}
                            contentStyle={style.removeModalPadding}
                            content={(<SettingsScreen store={this.props.store}/>)}/>;
        } else if (this.state.isHelpPagesOpen) {
            popupUI = (<ModalPopup id='helpPagePopup' store={this.props.store} modalType={HELP_PAGE_MODAL_TYPE}
                                   title={getText('HELP', this.props.store)} customStyle={style.helpPageModal}
                                   contentStyle={style.helpPagesContentStyle}
                                   content={(<HelpPageScreen store={this.props.store}/>)}/>);
        } else if (this.state.isAccumulatorBoostPagesOpen) {
            popupUI = (<ModalPopup2 id='AccumulatorBoostPagePopup' store={this.props.store}
                                   title={getText('ACCUMULATOR_BOOST', this.props.store)}
                                    overideStyle ={true}
                                   contentStyle={style.removeModalPadding}
                                   content={(<AccumulatorBoostScreen store={this.props.store}/>)}/>);
        } else if (this.state.isRealityCheckWarningOpen) {
            popupUI = (<ModalPopup id='RealityCheckWarningPopup' store={this.props.store}
                                   title={getText('WARNING_NOTIFICATION_REALITY_CHECK', this.props.store)}
                                   contentStyle={style.removeModalPadding} modalType={REALITY_CHECK_MODAL_TYPE}
                                   content={(<RealityCheckWarningScreen store={this.props.store}/>)}/>);
        } else if (this.state.isDemoplayNotificationOpen) {
            popupUI = (<ModalPopup id='demoplayWarningScreenPopup' store={this.props.store}
                                   title={getText('WARNING_NOTIFICATION_REALITY_CHECK', this.props.store)}
                                   contentStyle={style.removeModalPadding} modalType={REALITY_CHECK_MODAL_TYPE}
                                   content={(<DemoplayNotificationScreen store={this.props.store}/>)}/>);
        } else if (this.state.isGiftForYouOpen && OPERATOR.showBonusGift && !(hideGiftForYouFromLS)) {
                popupUI = (<ModalPopup2 id='GiftForYouOpen' store={this.props.store}
                                        title={getText('WARNING_NOTIFICATION_REALITY_CHECK', this.props.store)}
                                        contentStyle={style.removeModalPadding} modalType={REALITY_CHECK_MODAL_TYPE}
                                        content={(<GiftForYou store={this.props.store}/>)}/>);
        } else if (this.state.isMyOffersPopupOpen) {
            popupUI = (<ModalPopup2 id='myOffersPopup' store={this.props.store}
                                    title={getText('WARNING_NOTIFICATION_REALITY_CHECK', this.props.store)}
                                    contentStyle={style.removeModalPadding} modalType={REALITY_CHECK_MODAL_TYPE}
                                    content={(<MyOffersPopup store={this.props.store} />)}/>);
        } else if (this.state.isMyOffersListPopup) {
                     popupUI = (<ModalPopup2 id='demoplayWarningScreenPopup' store={this.props.store}
                                             backButton={false}
                                             title={getText('WARNING_NOTIFICATION_REALITY_CHECK', this.props.store)}
                                             contentStyle={style.removeModalPadding} modalType={MY_OFFER_LIST_MODAL_TYPE}
                                             content={(<MyOffersList store={this.props.store} />)} />);
                 }
        else if (this.state.isTermsAndConditionsPopupOpen) {
                popupUI = (<ModalPopup2 id='TermsAndConditionsPopup' store={this.props.store}
                                        backButton={true}
                                        title={getText('WARNING_NOTIFICATION_REALITY_CHECK', this.props.store)}
                                        contentStyle={style.removeModalPadding} modalType={REALITY_CHECK_MODAL_TYPE}
                                        content={(<TermsAndConditions store={this.props.store} />)}/>);
        }

        if (this.state.loadingBarPercentage) {
            return (<div className={style.loadingBarContainer}>
                <div className={style.loadingBarOutside}>
                    <div className={style.loadingBarText}>{getText('LOADING', this.props.store)}</div>
                    <div className={style.loadingBar} style={{width: this.state.loadingBarPercentage + '%'}}/>
                </div>
            </div>);
        }

        let betContainerContent = this.state.isBetSlipModalOpen ?
            this.state.isBetHistoryOpen
                ? <BetHistory store={this.props.store}/>
                : <BetSlipModal store={this.props.store} isCloseButtonPresent={false}/>
            : ''
        let bottomContainerStyle = this.state.showHeader ? ` ${style.bottomContainer} ${style.showHeaderBottomContainer}` : style.bottomContainer;
        let betSlipAccordion = this.state.isBetSlipSideView ? (
            <BetSlipAccordion label={'bet slip'} store={this.props.store} openBetsList={this.state.openBetsList}
                              content={betContainerContent}/>) : ''
        let betSlipModalContainer = !this.state.isBetSlipSideView ? (
                <div id={'betSlipModalContainer'} className={style.betSlipModalContainer}>
                    <BetSlipModalSliderContainer id='betSlipModalSliderContainer' store={this.props.store}
                                                 modalHeight={this.state.betslipModalHeight}/>
                </div>)
            : ''

        let game = this.state.games[this.state.selectedGameIndex];
        let gameContainerMatchday = game.type === MATCHDAY_MODULE_TYPE && this.state.selectedEventIndex === 0
        && game.controllerState && game.controllerState[1]
        && (game.controllerState[1] === VID || game.controllerState[1] === RES || isMatchdayNMB(storeData))
            ? style.gameOutsideContainerMatchday : '';
        let bannerDisplayStrategy =  OPERATOR.promoToolEnabled || OPERATOR.showMobileBanner;    
        let mobilePromoBannerStyle = this.state.isBetSlipModalOpen ? ` ${style.hidePromoBanners}` : bannerDisplayStrategy ? style.showPromoBanners: ` ${style.hidePromoBanners}`;
        let height = document.getElementById("mobileBannerId") ? document.getElementById("mobileBannerId").clientHeight : 0;
        if(height > 0){
            document.getElementById("gameScrollRight") ? document.getElementById("gameScrollRight").style.marginTop = `${height}px` : '';
            document.getElementById("gameScrollLeft") ? document.getElementById("gameScrollLeft").style.marginTop = `${height}px`: '';
            document.getElementById("subTabScrollLeft") ? document.getElementById("subTabScrollLeft").style.marginTop = `${height}px`: '';
            document.getElementById("subTabScrollRight") ? document.getElementById("subTabScrollRight").style.marginTop = `${height}px`: '';
        }else{
            document.getElementById("gameScrollRight") ? document.getElementById("gameScrollRight").style.marginTop = `-${height}px` : '';
            document.getElementById("gameScrollLeft") ? document.getElementById("gameScrollLeft").style.marginTop = `-${height}px`: '';
            document.getElementById("subTabScrollLeft") ? document.getElementById("subTabScrollLeft").style.marginTop = `-${height}px`: '';
            document.getElementById("subTabScrollRight") ? document.getElementById("subTabScrollRight").style.marginTop = `-${height}px`: '';
        }
        let defaultContent = (
            <div className={style.mainUpperContainer}>
                <Header store={this.props.store} reference={this.headerRef}/>
                <div id={'mobileBannerId'} className={`${mobilePromoBannerStyle}`}>
                    <SwipeablePromoMobileBanner store={this.props.store}/></div>
                <div className={style.topContainer} ref={this.topContainerRef}>
                    {<GameTabs id='gameTabs' store={this.props.store} containerRef={this.gametabContainerRef}/>}
                    {betSlipAccordion}
                </div>
                <div id='bottomContainer' className={`${bottomContainerStyle}`}
                     style={{height: (this.desktopContainerHeight)}}>
                    <div className={`${style.insideContainer}`} id='gameIframe'
                         style={{height: (this.mobileContainerHeight)}}>
                        <VerticalScrollController store={this.props.store}/>
                        <div className={style.videoEventTabsContainer}>
                            {carouselType}
                            {matchdayMoreBets}
                            {gameEventTabs}
                            {leagueUpdate}
                            {selectedFootballCard}
                            {selectedBasketballCard}
                            {selectedAmericanFootballCardCard}
                        </div>
                        <div id={'gameCardContainer'}
                             className={`${style.gameOutsideContainer}  ${gameContainerMatchday}`}>
                            <div id={'gameCard'} className={style.gameInsideContainer}>
                                {scrollTopButton}
                                {noFutureEventsCard}
                                {gameCard}
                            </div>
                        </div>
                    </div>
                    <div id={'sideContainer'} className={style.sideContainer}>
                        <GamePosters store={this.props.store}/>
                    </div>
                    {betSlipModalContainer}
                    {popupUI}{modalUI}
                </div>
            </div>);

        let fullViewPlayerContent = (
            <div className={style.fullViewPlayerContainer}>
                {carouselType}
            </div>
        );

        let content = this.state.isInFullViewPlayer ? fullViewPlayerContent : defaultContent;
        return (content);
    }

    _updateDimensions() {
        this._setBetSlipView()
        if (this.lastUpdatedWidth === undefined || (this.lastUpdatedWidth > window.innerWidth && window.innerWidth < resizeWidthInPx) || (this.lastUpdatedWidth < window.innerWidth && window.innerWidth > resizeWidthInPx)) {
            this._setDimensions();
        }
    }

    _setDimensions() {
        this.lastUpdatedWidth = window.innerWidth;
        this.lastUpdatedHeight = window.innerHeight;
        this.props.store.dispatch(setIsDesktopMode((window.innerWidth > resizeWidthInPx)));
    }

    _renderItems() {

        if (previousSelectedGameIndex === this.state.selectedGameIndex) {
            return (itemsUI);
        }


        itemsUI = VIRTUALS.map((g, index) => {

            let position;
            if (index === this.state.selectedGameIndex) {
                position = style.center;
            } else {
                if (index === this.state.selectedGameIndex - 1 || (index === (VIRTUALS.length - 1) && this.state.selectedGameIndex === 0)) {
                    position = style.left;
                } else if ((this.state.selectedGameIndex === (VIRTUALS.length - 1) && index === 0) || index === this.state.selectedGameIndex + 1) {
                    position = style.right;
                } else if (index < this.state.selectedGameIndex) {
                    position = style.left;
                } else {
                    position = style.right;
                }

                if (!(previousSelectedGameIndex !== undefined && previousSelectedGameIndex === index)) {
                    position += ' ' + style.hidden;
                }
            }

            let backgroundImageUrl = `${ASSETS_URL}${VIRTUALS[index].URL.BMS_ASSETS}/backplate.png`;

            return (<div key={index} className={`${style.backgroundImage} ${position}`}
                         style={{backgroundImage: `url(${backgroundImageUrl})`}}/>);
        });

        previousSelectedGameIndex = this.state.selectedGameIndex;

        return itemsUI;
    }

}

export default connect(mapStateToProps)(Main);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/main.js